import React from "react";


export const UserSkills = ({skills}) => {

  return(
    <div className="pr-user-stats">
      123
    </div>
  )
}